import Gardener from 'scoreboard/components/gardener'
import OrgGardener from 'scoreboard/organizations/organizations-gardener'
import ScorecardsGardener from 'scoreboard/scorecards/scorecards-gardener'
import InitiativesGardener from 'scoreboard/initiatives/initiatives-gardener'
import BriefingsGardener from 'scoreboard/briefings/briefings-gardener'
import metadataAliases from './metadata-aliases'
import DatasetsGardener from 'scoreboard/datasets/datasets-gardener'
import StrategyMapsGardener from 'scoreboard/strategy-maps/strategy-maps-gardener'
import DocumentsGardener from 'scoreboard/documents/documents-gardener'
import FormsGardener from 'scoreboard/forms/forms-gardener'
import CustomIconGardener from 'scoreboard/components/custom-icon-gardener'

var metadataGardeners = {

	organizations: OrgGardener,

	scorecards: ScorecardsGardener,

	dashboards: Gardener,

	initiatives: InitiativesGardener,

	files: DocumentsGardener,

	reports: CustomIconGardener,

	briefings: BriefingsGardener,

	datasets: DatasetsGardener,

	strategyMaps: StrategyMapsGardener,

	forms: FormsGardener,

	charts: Gardener

}

metadataAliases(metadataGardeners)

export default metadataGardeners

metadataGardeners.__filename__ = 'components/metadata-gardeners.js'
